import { AuthSessionManager } from "@app/AuthSessionManager.ts";
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: false },
    mutations: { retry: false },
  },
});

AuthSessionManager.subscribe(() => queryClient.clear());
